import ajax from 'aria-viewer/utils/ajax'
import qs from 'qs'
import { hideDrawer, showTourDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import {
    SET_IS_VRBUTTON_ENABLED,
    SET_ARE_SHAREBUTTONS_ENABLED,
    SET_ARE_ACTIONBUTTONS_ENABLED,
} from 'aria-viewer/config/configActions'
import { AUDIO_TOUR, stopAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import {
    openWelcomeRegistrationModal,
    openRegistrationModal,
    fetchRegistrationAttributes,
} from 'aria-viewer/registration/registrationActions'
import {
    WELCOME_PROMPT_HIDDEN,
    HIDDEN_BUTTON_CONFIGURATION,
    BTC_HIDE_ACTION_BUTTONS,
    BTC_HIDE_SHARE_BUTTONS,
    BTC_HIDE_VR_BUTTON,
} from 'aria-viewer/tour/constants/queryConstants'

import uriHandler from 'aria-viewer/utils/uriHandler'
import { setLanguage } from 'aria-viewer/language/languageActions'
import { intializeKeyboard } from 'aria-viewer/keyboard/keyboardActions'
import {
    faceForward,
    turnRight,
    turnLeft,
    FRONT,
    FRONT_INDEX,
    RIGHT,
    RIGHT_INDEX,
    LEFT,
    LEFT_INDEX,
} from 'aria-viewer/navigation/navigationActions'
import { SET_MAP_DATA } from 'aria-viewer/map/mapActions'
import { lowerStopCards } from 'aria-viewer/stopselector/actions/stopCardsActions'
import { hideSlidePanel } from 'aria-viewer/slidepanel/slidePanelActions'
import { VideoPlayerActions } from 'aria-viewer/players/videoplayer'

import {
    getNext,
    getPrev,
    getStopTrailPoint,
    applyExperienceUpdated,
    hasMultipleToursLocations,
} from 'aria-viewer/utils/functions'
import ModalSources from 'aria-viewer/modal/constants/ModalSources'
import { MEDIA_PROPS_LIST, TOUR_TYPES, MEDIA_TYPES } from 'aria-viewer/tour/constants'
import {
    PaymentConstants,
    buildHotspotsPaymentCatalog,
    formatCreditCardsMap,
    setPaymentItemCatalog,
    setAccountNetworks,
    setFormValues,
    setCreditCards,
    setAPIKey,
    setIsUserAuthenticated,
    updateHasExpressCheckout,
    setPaymentShippingMethodsOptions,
    setShippingMethod,
    setIsPaymentEnabled,
} from 'aria-viewer/payments'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import MediaContextTypes from 'aria-viewer/tour/constants/MediaContextTypes'
import { MODEL_DATA } from 'aria-viewer/metamodels/metaModelActions'
import { setRegistrationFormType } from 'aria-viewer/registration/registrationActions'
import {
    ANALYTICS_SET_USER_KEY,
    setSessionId,
    ANALYTICS_FIRST_STOP_VIEWED,
} from 'aria-viewer/analytics/analyticActions'
import Analytics from 'aria-viewer/analytics/utils/analytics'
import SessionStorage from 'aria-viewer/utils/sessionStorage'

import 'public/assets/css/accessibility'
import { AccessibilityController, WTPhotoController } from '../legacy'
import { setMediaPaths } from 'aria-viewer/media/mediaTransformer'
import { HIDE_DRAWER, TOUR_DRAWER } from 'aria-viewer/drawer/drawerMenuActions'
import { openModal, closeModal } from 'aria-viewer/modal/modalActions'
import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import { TourActions } from './constants'
import { hideAvatar, showAvatar } from 'aria-viewer/guide/avatarActions'
import { normalizeData } from '../interactive-element/methods/normalizeData'
import { hydrateInteractive } from '../interactive-element/actions/common'
import Cookie from '../utils/cookie'
import { getAnalyticsMiddleware } from 'aria-viewer/core/middleware/analyticsMiddleware'
import { addMiddleware } from 'redux-dynamic-middlewares'
import {
    USER_REGISTRATION_OPT_IN_PROMPT_SHOWN,
    USER_REGISTRATION_OPT_IN_PROMPT_BUTTON_CLICK,
} from 'aria-viewer/analytics/constants'
import { getEnv } from 'aria-viewer/utils/environment'
import SocketProxy from 'aria-viewer/analytics/utils/socket/socketProxy'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

export const userIdled = () => ({ type: TourActions.USER_IS_IDLE })

export const resetTourData = () => ({ type: TourActions.RESET_TOUR_DATA })

export const setLocations = (inst_id, loc_id) => (dispatch, getState) => {
    return analyticsMiddleware => {
        dispatch(setTourLoadingStatus(true))

        fetchRegistrationAttributes(inst_id, loc_id)(dispatch, getState).then(val => {
            const {
                analyticsData: { analytics, experience_updated },
            } = val

            /**
             * GDPR Compliance requires our user to provide consent for tracking analytics
             * Phase 1: is not to track
             *
             * If disabled is not explicitly true then don't track. Otherwise continue to track.
             */
            if (
                analytics.disabled !== true &&
                (getEnv('REACT_APP_ANALYTICS_ENABLED') || '').toLowerCase() !== 'false'
            ) {
                addMiddleware(...getAnalyticsMiddleware(analyticsMiddleware))
            }

            const apiData = applyExperienceUpdated(
                {
                    limit: 1000,
                    allowInProgress: ['locations', 'tours'].join(','),
                },
                experience_updated
            )

            ajax.getApi(`/institutions/${inst_id}`, apiData).then(({ data }) => {
                if (data.error) {
                    dispatch([
                        setTourLoadingStatus(false),
                        {
                            type: TourActions.ERROR,
                            value: data.error,
                        },
                    ])
                    return
                }

                const { client, locations } = data[0]

                dispatch([
                    {
                        type: TourActions.SET_INSTITUTION,
                        instid: inst_id,
                        isClient: client,
                    },
                    {
                        type: TourActions.SET_LOCATIONS,
                        locations: locations.map(({ tours, ...location }) => location),
                    },
                    {
                        type: TourActions.SET_TOURS,
                        tours: locations.reduce((tours, location) => {
                            return [...tours, ...location.tours]
                        }, []),
                    },
                ])
            })
        })
    }
}

export const setTourTitle = title => ({
    type: TourActions.SET_TOUR_TITLE,
    title,
})

export const setTourFontFace = fontFace => ({
    type: TourActions.SET_FONT_FACE,
    fontFace,
})

export const setIsExperienceOffline = isExperienceOffline => ({
    type: TourActions.SET_IS_EXPERIENCE_OFFLINE,
    isExperienceOffline,
})

export const setExperienceUpdated = experienceUpdated => ({
    type: TourActions.SET_EXPERIENCE_UPDATED,
    experienceUpdated,
})

export const setClient = value => {
    return {
        type: TourActions.SET_CLIENT,
        value,
    }
}

export const completeInitTour = ({
    inst_id,
    loc_id,
    tourid,
    loc_query,
    language,
    _location: location,
    _stops: stopData,
    _models: models,
    _normalized: normalized,
    _analytics,
    _registration,
    loadSingleStopOnly,
    stopid,
    fromVR,
    videoStartTime,
    params,
}) => (dispatch, getState) => {
    if (!location || !stopData) {
        return
    }
    location = {
        ...location,
        stops: stopData,
    }

    const state = getState()

    const tour = state.get('tour')
    const locations = tour.get('locations')
    const locIndex = locations.get('list').findIndex(location => location.loc_id == loc_id)

    if (stopData.length == 0) {
        dispatch({
            type: TourActions.ERROR,
            value: 'Invalid Location',
        })
        return
    }

    const trails = location.tours.reduce((trails_map, tour) => {
        return {
            ...trails_map,
            [tour.tourid]: tour.trails,
        }
    }, {})

    const points = location.tours.reduce((points_map, { trails }) => {
        return trails.reduce((points_map, trail) => {
            return {
                ...points_map,
                [trail.id]: trail.points,
            }
        }, points_map)
    }, {})

    const stop_tour_list = location.tours.reduce((tour_stop, tour) => {
        return {
            ...tour_stop,
            [tour.tourid]: tour.trails.reduce((stop_list, trail) => {
                return trail.points.reduce((stop_list, point) => {
                    return {
                        ...stop_list,
                        [point.stopid]: true,
                    }
                }, stop_list)
            }, {}),
        }
    }, {})

    const stops = location.tours.reduce((stops_map, tour) => {
        //map tourid to stops list
        return {
            ...stops_map,
            [tour.tourid]: tour.trails.reduce((stops, { points }) => {
                return points.reduce((stops, point) => {
                    const stop = location.stops.find(stop => stop.stopid === point.stopid)
                    if (
                        point.main &&
                        stop &&
                        !stops.includes(stop) &&
                        /* If not a Media Tour, ie can derive from point */
                        (((tour.type == TOUR_TYPES.hybridtour || tour.type == TOUR_TYPES.walkingtour) &&
                            stop_tour_list[tour.tourid] &&
                            stop_tour_list[tour.tourid][stop.stopid]) ||
                            ((tour.type == TOUR_TYPES.hybridtour || tour.type == TOUR_TYPES.mediatour) &&
                                /* OR jas media tour main media */
                                (stop.main_media_id &&
                                    stop.main_media_type &&
                                    /* AND ensure the media exists */
                                    stop[`${stop.main_media_type}s`].find(({ id }) => id === stop.main_media_id))))
                    ) {
                        return [...stops, stop]
                    }
                    return stops
                }, stops)
            }, []),
        }
    }, {})

    const { defaultLanguage, selectedLanguage } = location.languages.reduce((languageOptions, value) => {
        if (language == value.language) {
            return {
                ...languageOptions,
                selectedLanguage: value,
            }
        }
        if (value.is_default) {
            return {
                ...languageOptions,
                defaultLanguage: value,
            }
        }
        return languageOptions
    }, {})

    if (location.payments && location.payments.is_enabled) {
        const { publishableKey, shipping_options } = location.payments

        if (publishableKey) {
            dispatch(setAPIKey(publishableKey))

            let hotspots = {},
                triggers = {},
                positionalMedia = {}

            for (const mediaType of MEDIA_PROPS_LIST) {
                for (const stop of stops[tourid]) {
                    const stopMediaItems = stop[mediaType]

                    for (const media of stopMediaItems) {
                        // Separate out triggers and hotspots. If hotspot has the property category then it's
                        // considered a trigger.
                        if (media.hotspots) {
                            for (const hotspot of media.hotspots) {
                                if (hotspot.category) triggers[media.id] = [...(triggers[media.id] || []), hotspot]
                                else hotspots[media.id] = [...(hotspots[media.id] || []), hotspot]
                            }
                        }

                        if (media.objs) positionalMedia[media.id] = media.objs
                    }
                }
            }

            fetchPaymentDataAndAccounts(loc_id).then(({ paymentData, accountNetworks, isLoggedIn }) => {
                // TODO: Need to filter out non-payment hotspots from buildHotspotsPaymentCatalog output.
                const { hotspots: paymentHotspots, catalog } = buildHotspotsPaymentCatalog({
                    hotspots,
                    paymentData,
                })

                const defaultShippingMethod = shipping_options[0]
                let filteredPaymentHotspots = {},
                    filteredHotspots = {}

                for (const [mediaID, paymentHotspot] of Object.entries(paymentHotspots)) {
                    for (const hotspot of Object.values(paymentHotspot)) {
                        if (hotspot.payments_product_id) {
                            filteredPaymentHotspots[mediaID] = [...(filteredPaymentHotspots[mediaID] || []), hotspot]
                        } else {
                            filteredHotspots[mediaID] = [...(filteredHotspots[mediaID] || []), hotspot]
                        }
                    }
                }

                let paymentActions = [
                    setIsPaymentEnabled({ enabled: true }),
                    setHotspots(filteredHotspots), // TODO: Setting payment hotspots should be called via the setPaymentHotspots action when view has been updated.
                    setPaymentHotspots(filteredPaymentHotspots),
                    setPaymentItemCatalog({ catalog }),
                    setIsUserAuthenticated({ isAuthenticated: isLoggedIn }),
                    setPaymentShippingMethodsOptions({ shippingOptions: shipping_options }),
                    setShippingMethod({
                        shippingMethodId: defaultShippingMethod ? defaultShippingMethod.id : '',
                        price: defaultShippingMethod ? defaultShippingMethod.price : 0,
                    }),
                ]
                const stripeCustomer = (accountNetworks || []).find(
                    accountNetwork => accountNetwork.network == PaymentConstants.networks.STRIPE
                )

                if (stripeCustomer) {
                    const {
                        network,
                        foreignId,
                        id,
                        shippingCity,
                        shippingCountry,
                        shippingLine1,
                        shippingName,
                        shippingPostalCode,
                        shippingState,
                        email,
                        phone,
                        creditCards,
                    } = stripeCustomer

                    const creditCardsMap = formatCreditCardsMap({
                        creditCards: creditCards,
                    })

                    paymentActions.push(
                        setAccountNetworks({
                            networks: {
                                [network]: {
                                    foreignId,
                                    id,
                                },
                            },
                        }),
                        setFormValues({
                            formName: PaymentConstants.formNames.SHIPPING_ADDRESS,
                            values: {
                                fullName: shippingName,
                                address: shippingLine1,
                                zipcode: `${shippingPostalCode}`,
                                town: shippingCity,
                                country: shippingCountry,
                                state: shippingState,
                                email: email ? email : '',
                                phone: phone ? phone : '',
                            },
                        }),
                        setCreditCards({ creditCards: creditCardsMap }),
                        updateHasExpressCheckout()
                    )
                }

                dispatch(paymentActions)
            })
        } else {
            console.error('Location has payments enabled with no publishable key.')
        }
    } else {
        dispatch(setIsPaymentEnabled({ enabled: false }))
    }

    const mainTour = location.tours.find(tour => tour.tourid == tourid)
    var ua = navigator.userAgent.toLowerCase()
    var isAndroid = ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1
    //Determine if we are in a hybrid app based on platform identifier
    const isAndroidApp = window.location.href.indexOf('pl=a') != -1
    const isIphoneApp = window.location.href.indexOf('pl=i') != -1
    let isAppAvailable = (isAndroid && location.mobile) || (!isAndroid && location.mobile)
    const { vr_app } = location

    const isPhone = state.getIn(['device', 'isDevicePhone'])

    setMediaPaths(models)

    initWalkingTourPhotos(mainTour, models)(dispatch, getState)

    intializeKeyboard()(dispatch, getState)

    /**
     * Initialize Analytics before starting dispatches to setup system
     */
    //Specifically this will allow us to record first stop.
    Analytics.init({
        inst_id,
        loc_id,
        autoload: false,
    })

    let tourInitBatchedActions = [
        setClient({
            isAppAvailable,
            image:
                vr_app && vr_app.icon_url
                    ? vr_app.icon_url
                    : 'https://s3-external-1.amazonaws.com/youvisit-img/mobilevr/default.png',
            isClientApp: isAndroidApp || isIphoneApp,
        }),
        {
            type: TourActions.SET_LOCATION,
            current: locIndex,
            location,
        },
        lowerStopCards(),
        hideSlidePanel(),
        {
            type: TourActions.SET_STOPS_CACHE,
            stops,
        },
        {
            type: TourActions.SET_TRAILS_CACHE,
            trails,
        },
        {
            type: TourActions.SET_POINTS,
            points,
        },
        {
            type: SET_MAP_DATA,
            data: location.interactivemaps[0],
        },
        {
            type: TourActions.SET_TOUR,
            current: tourid,
            tour: mainTour,
        },
        setActionButtons(location.actionButtons),
        {
            type: MODEL_DATA,
            models,
        },
        {
            type: FRONT,
        },
        {
            type: TourActions.SET_TRAIL,
            current: 0,
        },
        setPoint(0),
        hydrateInteractive(normalized),
    ]

    dispatch(tourInitBatchedActions)

    try {
        const { enabled: registrationEnabled, autoLaunch, launchTime, formType } = _registration

        const { hasCookieConsent, original_platform, platform, sessionId, userkey } = _analytics

        const referralurl = document.referrer
        const isIWC = state.getIn(['device', 'isInIframe']) && state.getIn(['device', 'useResponsiveUI'])
        const socket = isIWC ? SocketProxy : undefined

        Analytics.load({ ..._analytics, socket, analyticsUrl: process.env.REACT_APP_ANALYTICS_WEBSOCKET_ENDPOINT })

        if (hasCookieConsent) {
            executeTrackingPixel(inst_id, loc_id, original_platform, referralurl)
        }

        dispatch([
            {
                type: ANALYTICS_SET_USER_KEY,
                userkey,
            },
            {
                type: TourActions.SET_PLATFORM,
                platform,
            },
            {
                type: TourActions.SET_ORIGINAL_PLATFORM,
                original_platform,
            },
            setSessionId(sessionId),
        ])

        let batchedActions = []

        if (selectedLanguage || defaultLanguage) {
            //only set language if available.
            batchedActions = [...batchedActions, setLanguage(selectedLanguage || defaultLanguage)]
        }

        batchedActions = [
            ...batchedActions,
            {
                type: TourActions.SET_DISPLAY_SINGLE_STOP,
                loadSingleStopOnly,
            },
            setRegistrationAutoLaunch(autoLaunch),
            setRegistrationEnabled(registrationEnabled),

            // PUTS CIF REGISTRATION BEHIND FLAG FOR TESTING
            setRegistrationFormType(QueryParamUtils.useConversationalInquiryForm() ? 'cif' : formType),
        ]

        if (registrationEnabled && !isPhone) {
            if (autoLaunch) {
                /* Auto launch Registration based on Certain Time. */
                setTimeout(() => {
                    dispatch(openRegistrationModal(ModalSources.WELCOME_PROMPT))

                    // skip_prompt cookie is set to let backened toggle autoLaunch
                    Cookie.set(`skip_prompt_${loc_id}`, '1', 30, '.youvisit.com')
                }, launchTime)
            } else {
                batchedActions = [setTourLoadingStatus(false), ...batchedActions]
            }
        }

        if (!registrationEnabled || isPhone) {
            batchedActions = [setTourLoadingStatus(false), ...batchedActions]
        }

        // end tour loading
        dispatch(batchedActions)

        // Depends on registrationEnabled
        if (!isIWC) dispatch(showWelcomePrompt({ tourid, location }))
    } catch (e) {
        console.error(e)
    }

    //sets from vr app
    if (fromVR) {
        dispatch(setFromVR(fromVR))
    }

    //Load the shareURL
    const locParams = loc_query ? loc_query.split(':') : null
    if (locParams) {
        try {
            //Set the current trail
            const { trail_index, trail } = trails[tourid].reduce((trail, prop, index) => {
                if (prop.trailid == locParams[0]) {
                    return {
                        trail_index: index,
                        trail: prop,
                    }
                }
                return trail
            }, {})
            const pointIndexParam = parseInt(locParams[1])
            const point_index = isNaN(pointIndexParam) ? 0 : Math.min(pointIndexParam, points[trail.id].length - 1)
            dispatch(
                goToPoint(() => {
                    return {
                        points_current: point_index,
                        trails_current: trail_index,
                    }
                })
            )
            //Adjust the orientation
            const faceDirectionParam = parseInt(locParams[2])
            if (!isNaN(faceDirectionParam) && faceDirectionParam != FRONT_INDEX) {
                dispatch(pointTurn(faceDirectionParam))
            }
            return
        } catch (error) {
            //error occurs when locparams are bad.
        }
    }
    //Load the initial stop
    //this intercepts the stopid and sets the starting stop
    let stopIndex = 0
    if (stopid) {
        let getStopIndex = stops[tourid].findIndex(stop => stop.stopid == stopid)
        if (getStopIndex && getStopIndex != -1) {
            stopIndex = getStopIndex
        }
    }

    dispatch(setStop(stopIndex, true))

    // set the video start time
    if (
        (stops[tourid][stopIndex].main_media_type == MEDIA_TYPES.video || stops[tourid][stopIndex].intro_media) &&
        videoStartTime
    ) {
        dispatch(VideoPlayerActions.setStartTime(parseInt(videoStartTime)))
    }

    dispatch(initTourDrawer({ tourid, location, params }))
    dispatch(tourInitializedComplete(true))
}

export const tourInitializedComplete = isTourInitializedComplete => ({
    type: TourActions.TOUR_INITIALIZED_COMPLETE,
    isTourInitializedComplete,
})

export const initTour = ({
    inst_id,
    loc_id,
    tourid,
    loc_query,
    language,
    loadSingleStopOnly,
    stopid,
    fromVR,
    videoStartTime,
    params,
}) => {
    SessionStorage.setTourID(loc_id, tourid)

    return async (dispatch, getState) => {
        dispatch(setTourLoadingStatus(true))
        dispatch(loadTourParamConfiguration())

        const state = getState()

        const hasTourBeenInitialized = state.getIn(['tour', 'isTourInitializedComplete'])
        let analyticAttributes
        let registrationAttributes
        let experienceUpdated

        /**
         * If tour has been intialized previously then this indicates that the tour needs to be reintialized
         * with new analytics and registration params. If so let's fetch this.
         */
        if (hasTourBeenInitialized) {
            const {
                analyticsData: { analytics, experience_updated, registration },
            } = await fetchRegistrationAttributes(inst_id, loc_id)(dispatch, getState)

            analyticAttributes = analytics
            registrationAttributes = registration
            experienceUpdated = experience_updated
        } else {
            analyticAttributes = state.getIn(['analytics', 'analyticAttributes'])
            registrationAttributes = state.getIn(['registration', 'registrationAttributes'])
            experienceUpdated = state.getIn(['tour', 'experienceUpdated'])
        }

        const getLocationsRequest = new Promise((resolve, reject) => {
            /* List available locations */
            const locationAPIData = applyExperienceUpdated(
                {
                    expand: ['tours', 'actionButtons', 'interactivemaps'].join(','),
                    allowInProgress: ['locations', 'tours'].join(','),
                    limit: 1000,
                    mobile: state.getIn(['device', 'isDevicePhone']),
                },
                experienceUpdated
            )

            ajax.getApi(`/institutions/${inst_id}/locations/${loc_id}`, locationAPIData).then(({ data, error }) => {
                if (error) {
                    reject(`Location Request Failed: ${error}`)
                } else {
                    resolve({
                        locationData: data[0],
                    })
                }
            })
        })

        const getStopsRequest = new Promise((resolve, reject) => {
            /* Load our Available Stops */
            const stopsAPIData = applyExperienceUpdated(
                {
                    expand: 'all',
                    allowInProgress: ['locations', 'tours'].join(','),
                    limit: 1000,
                },
                experienceUpdated
            )

            ajax.getApi(`/institutions/${inst_id}/locations/${loc_id}/stops`, stopsAPIData).then(d => {
                const {
                    data,
                    meta: { models },
                    error,
                } = d
                if (error) {
                    reject(`Stops Request Failed: ${error}`)
                } else {
                    const normalized = normalizeData(d)
                    resolve({
                        stopData: data,
                        metaData: models,
                        normalized,
                    })
                }
            })
        })

        /* Resolve API Calls */
        Promise.all([getLocationsRequest, getStopsRequest]).then(
            //If success, process the values
            values => {
                //Go through the values array to find the data from api calls
                const { locationData, stopData, metaData, normalized } = values.reduce((results, data) => {
                    return { ...results, ...data }
                }, {})
                completeInitTour({
                    inst_id,
                    loc_id,
                    tourid,
                    loc_query,
                    language,
                    _location: locationData,
                    _stops: stopData,
                    _models: metaData,
                    _normalized: normalized,
                    _analytics: analyticAttributes,
                    _registration: registrationAttributes,
                    loadSingleStopOnly,
                    stopid,
                    fromVR,
                    videoStartTime,
                    params,
                })(dispatch, getState)
            },
            //If error, log the reason why one of the requests failed
            reason => {
                dispatch({
                    type: TourActions.ERROR,
                    //Commenting out the actual reason for failure since it's not very user friendly
                    // value : reason
                    value: 'Tour Under Construction',
                })
            }
        )
    }
}

const fetchPaymentDataAndAccounts = loc_id => {
    const fetchPaymentData = new Promise((resolve, reject) => {
        ajax.getApi(`/locations/${loc_id}/paymentsProducts`).then(({ data, error }) => {
            if (error) {
                reject(`Payment Products Request Failed: ${error}`)
            } else {
                resolve({
                    paymentData: data,
                })
            }
        })
    })

    const fetchAccountNetworks = new Promise((resolve, reject) => {
        ajax.getApi('/accountNetworks', { withCredentials: true }).then(
            ({ data, error, meta = { isLoggedIn: false } }) => {
                if (error) resolve({ accountNetworks: false })
                else resolve({ accountNetworks: data, isLoggedIn: meta.isLoggedIn })
            }
        )
    })

    return Promise.all([fetchPaymentData, fetchAccountNetworks]).then(responses => {
        // Merge an array of reponses into a single object
        return responses.reduce(
            (response, data) => ({
                ...response,
                ...data,
            }),
            {}
        )
    })
}

let locationId = ''
let referrerUrl = null

/**
 * Calls tracking pixel api only if inside of embed script.
 *
 * A message is sent to the parent. If a response is obtained then we're inside an embedded tour.
 * After 5 seconds make an XHR request to tracking pixel URL.
 */
const executeTrackingPixel = (inst_id, loc_id, platform, sourceUrl) => {
    locationId = loc_id
    let directLink = false

    // THis is temporary. For now we are disabling sending a pixel if someone
    // switches the experience through the experience selections screen
    if (referrerUrl !== null) return

    if (referrerUrl == null) {
        referrerUrl = window.location.search
        referrerUrl = referrerUrl.split('reff=')
        if (referrerUrl.length > 1) {
            referrerUrl = referrerUrl[1]
        } else if (platform == 'vhost' && sourceUrl != undefined && sourceUrl.indexOf('youvisit.com') == -1) {
            referrerUrl = sourceUrl
            directLink = true
        } else {
            referrerUrl = null
        }
    }

    if (referrerUrl !== null) {
        let type = 'exper'
        let params = ''
        if (directLink) {
            type = 'direct'
        } else {
            const { embed_type, embed, ab, estid } = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
            })

            params =
                `${embed_type ? '&embed_type=' + embed_type : ''}` +
                `${embed ? '&embed=' + embed : ''}` +
                `${ab ? '&ab=' + ab : ''}` +
                `${estid ? '&estid=' + estid : ''}`
        }
        setTimeout(() => {
            let url = `${getEnv(
                'REACT_APP_TRACKING_PIXEL_URL'
            )}/${type}/${inst_id}/${locationId}.png?${params}&referrer=${referrerUrl}`
            document.body.insertAdjacentHTML(
                'beforeend',
                '<img alt="youvisit experience pixel" src="' + url + '" style="display:none;" />'
            )
        }, 5000)
    }
}

//this action sets the tour loading status explicitly
export const setTourLoadingStatus = loadingStatus => ({
    type: TourActions.LOADING,
    value: { tour: loadingStatus },
})

/**
 * Action Creator for setting state of Config based on Query String
 */
export const loadTourParamConfiguration = () => {
    return (dispatch, getState) => {
        const routeInfo = getState().getIn(['routing'])
        if (routeInfo && routeInfo.location) {
            const query = routeInfo.location.query
            const btcg = query[HIDDEN_BUTTON_CONFIGURATION]
            if (btcg > 0) {
                //button configurations
                dispatch([
                    {
                        type: SET_IS_VRBUTTON_ENABLED,
                        value: !((btcg & BTC_HIDE_VR_BUTTON) > 0),
                    },
                    {
                        type: SET_ARE_SHAREBUTTONS_ENABLED,
                        value: !((btcg & BTC_HIDE_SHARE_BUTTONS) > 0),
                    },
                    {
                        type: SET_ARE_ACTIONBUTTONS_ENABLED,
                        value: !((btcg & BTC_HIDE_ACTION_BUTTONS) > 0),
                    },
                ])
            }
        }
    }
}

export const setFromVR = fromVR => ({ type: TourActions.FROM_VR, fromVR })

export const setActionButtons = actionButtons => ({
    type: TourActions.SET_ACTION_BUTTONS,
    actionButtons,
})

export const firstStopViewed = () => ({
    type: ANALYTICS_FIRST_STOP_VIEWED,
})

export const setRegistrationAutoLaunch = autoLaunch => ({
    type: TourActions.SET_REGISTRATION_AUTOLAUNCH,
    autoLaunch,
})

export const setRegistrationEnabled = enabled => ({
    type: TourActions.SET_REGISTRATION_ENABLED,
    enabled,
})

export const setRegistrationWelcomePrompt = prompt => ({
    type: TourActions.SET_REGISTRATION_WELCOME_PROMPT,
    prompt,
})

export const setWelcomePrompt = prompt => ({
    type: TourActions.SET_WELCOME_PROMPT,
    prompt,
})

export const openWelcomeModal = () => {
    return dispatch => {
        dispatch([
            openModal(ModalTypes.ALERT, {
                type: ModalContentTypes.WELCOME,
                hasIndependentContainer: true,
            }),
            setWelcomePrompt(true),
        ])
    }
}

export const closeWelcomeModal = () => {
    return dispatch => {
        dispatch([closeModal(), setWelcomePrompt(false)])
    }
}

export const setPanoramaParams = ({ size, panoType }) => {
    return (dispatch, getState) => {
        const state = getState()
        const oldSize = state.getIn(['tour', 'currentPanoramaParams', 'size'])
        if (size != oldSize) {
            dispatch({
                type: TourActions.SET_PANORAMA_PARAMS,
                size,
                panoType,
            })
        }
    }
}

export const setStop = (current, disableHide = false) => {
    return (dispatch, getState) => {
        const state = getState()
        const tour = state.get('tour')
        const navigation = state.get('navigation')

        let batchedActions = [
            {
                type: TourActions.SET_STOP,
                current,
            },
        ]

        // upon entering a stop the assumption is the user will always face forward
        if (navigation.get('orientation') !== FRONT) {
            batchedActions = [...batchedActions, faceForward()]
        }

        const drawerName = state.getIn(['drawerMenu', 'name'])

        if (disableHide && ![HIDE_DRAWER, TOUR_DRAWER].includes(drawerName)) {
            batchedActions = [...batchedActions, hideDrawer()]
        }

        if (tour.altMainMedia) {
            batchedActions = [
                ...batchedActions,
                {
                    type: TourActions.SKIPPED_ALT_MAIN_MEDIA,
                    skipped: false,
                },
            ]
        }

        dispatch(batchedActions)
    }
}

export const stopChanged = (previous, current) => {
    return {
        type: TourActions.STOP_CHANGED,
        previous,
        current,
    }
}

export const checkIntroMedia = () => {
    return (dispatch, getState) => {
        const state = getState()
        const stops = state.get('tour').get('stops')
        const altMainMedia = state.get('tour').get('altMainMedia')
        const currentStop = stops.getIn(['list', stops.get('current')])

        // if the intro was already played on that stop, don't play it again
        const isStopIntroPlayed = stops.getIn(['isStopIntroPlayed', currentStop.stopid])

        if (
            currentStop.intro_media &&
            !isStopIntroPlayed &&
            (!altMainMedia || altMainMedia.stopid != currentStop.stopid)
        ) {
            const mediaItem = currentStop.videos.find(({ id }) => id === currentStop.intro_media)
            if (mediaItem) {
                const media = Object.assign({}, mediaItem, {
                    contextType: MediaContextTypes.INTRO_VIDEO,
                    skipButtonTitle: 'Skip Intro',
                    stopid: currentStop.stopid,
                    disableShowDragHintOnLoad: true,
                })
                // these arent batched because showCustomMedia is already
                // firing a batch, it also needs to be able to dispatch
                // from somewhere else
                dispatch(showCustomMedia(media))
                dispatch(showUIButton(false))
            }
        }
    }
}

const setPoint = current => ({
    type: TourActions.SET_POINT,
    current,
})

const goToPoint = point => {
    return {
        type: TourActions.GO_TO_POINT,
        point,
    }
}

export const setTrail = (current_trail, lastPoint = false) => {
    return (dispatch, getState) => {
        const tour = getState().get('tour')
        const trails = tour.get('trails')
        const points = tour.get('points')
        const trail_index = trails.get('list').reduce((trail_index, prop, index) => {
            if (prop.trailid == current_trail.trailid) {
                return index
            }
            return trail_index
        }, -1)

        if (trail_index >= -1) {
            dispatch(
                goToPoint(() => {
                    return {
                        points_current: lastPoint ? points.get('list')[current_trail.id].length - 1 : 0,
                        trails_current: trail_index,
                    }
                })
            )
        }
    }
}

export const nextPoint = () => {
    return (dispatch, getState) => {
        let actions = [
            goToPoint(getNext),
            {
                type: TourActions.NEXT_POINT,
            },
        ]
        const intro = getState().getIn(['tour', 'skippedAltMainMedia'])
        dispatch(intro ? [...actions, { type: TourActions.SKIPPED_ALT_MAIN_MEDIA, skipped: false }] : actions)
    }
}

export const prevPoint = () => {
    return (dispatch, getState) => {
        let actions = [
            goToPoint(getPrev),
            {
                type: TourActions.PREV_POINT,
            },
        ]
        const intro = getState().getIn(['tour', 'skippedAltMainMedia'])
        dispatch(intro ? [...actions, { type: TourActions.SKIPPED_ALT_MAIN_MEDIA, skipped: false }] : actions)
    }
}

export const pointTurn = orientation => {
    switch (orientation) {
        case FRONT_INDEX:
        case FRONT:
            return faceForward()
        case LEFT_INDEX:
        case LEFT:
            return turnLeft()
        case RIGHT_INDEX:
        case RIGHT:
            return turnRight()
    }
}

export const showCustomMedia = media => {
    return (dispatch, getState) => {
        dispatch([
            {
                type: TourActions.SHOW_ALT_MEDIA,
                media,
            },
            {
                type: TourActions.SKIPPED_ALT_MAIN_MEDIA,
                skipped: false,
            },
        ])
    }
}

export const hideCustomMedia = (params = { initializeMainMedia: true }) => {
    return (dispatch, getState) => {
        const state = getState()

        const stops = state.getIn(['tour', 'stops'])
        const currentStop = stops.getIn(['list', stops.get('current')])

        const currentStopId = currentStop.stopid
        const currentStopIntroId = currentStop.intro_media
        const altMainMedia = state.get('tour').get('altMainMedia')
        const isStopIntroPlayed = stops.getIn(['isStopIntroPlayed', currentStopId])
        const openTriggerId = state.getIn(['interactiveElements', 'openTriggerId'])

        // on intro hide, track that the intro has already been played or skipped
        if (altMainMedia && !isStopIntroPlayed && currentStopIntroId == altMainMedia.id) {
            dispatch([
                {
                    type: TourActions.SET_IS_STOP_INTRO_PLAYED,
                    currentStopId,
                },
            ])
        }

        //is there's opentriggerid, reset it to empty so the trigger wont stay open
        //on in mobile
        if (openTriggerId) dispatch(setOpenTrigger())

        let actions = [
            {
                type: TourActions.SHOW_ALT_MEDIA,
                media: null,
            },
            {
                type: TourActions.SKIPPED_ALT_MAIN_MEDIA,
                skipped: true,
            },
            {
                type: TourActions.SHOW_SKIP,
                visible: false,
            },
        ]

        if (params.initializeMainMedia) {
            actions = [
                {
                    type: TourActions.MAIN_MEDIA_INITIALIZED,
                    initialized: false,
                },
                ...actions,
            ]
        }

        dispatch(actions)

        setTimeout(() => {
            AccessibilityController.modalDismissed(false)
        }, 500)
    }
}

export const setMainMediaStalling = isStalling => ({
    type: TourActions.MAIN_MEDIA_IS_STALLING,
    isStalling,
})

export const setMainMediaLoadingStatus = status => {
    return {
        type: TourActions.MAIN_MEDIA_LOADING_STATUS,
        loadingStatus: status,
    }
}

export const setMainMediaInitialized = initialized => {
    return {
        type: TourActions.MAIN_MEDIA_INITIALIZED,
        initialized: initialized,
    }
}

export const setMainMediaType = mediaType => ({
    type: TourActions.MAIN_MEDIA_TYPE,
    mediaType,
})

export const setMainMediaDimensions = dimension => ({
    type: TourActions.SET_MAIN_MEDIA_DIMENSION,
    dimension,
})

export const setMainMediaPhotoPlayerBoundingRect = boundingRect => ({
    type: TourActions.SET_MAIN_MEDIA_PHOTO_PLAYER_BOUNDING_RECT,
    boundingRect,
})

export const launchAccessibilityExperience = () => {
    return (dispatch, getState) => {
        const state = getState()
        const locationsList = state.getIn(['tour', 'locations', 'list'])
        const locationIndex = state.getIn(['tour', 'locations', 'current'])
        const tourid = state.getIn(['tour', 'tours', 'current'])
        const location = locationsList[locationIndex] || {}
        const loc_id = location.loc_id || ''
        const owner_unique_id = location.inst_unique_id || location.owner_id
        const reg = /pl=(\w+)/g.exec(window.location.search)
        const hasHover = /hover=(\w+)/g.exec(window.location.search)
        const platform = reg && reg.length > 0 ? reg[0] : ''
        const ADAUrl = `/tour/ada/${owner_unique_id}/${loc_id}?tourid=${tourid}&${platform}`

        //Stop the Audio
        dispatch(stopAudio(AUDIO_TOUR))

        dispatch({
            type: TourActions.LAUNCH_ADA_MODE,
            value: {
                inst_id: owner_unique_id,
                loc_id: loc_id,
            },
        })

        //try to open in a new tab. As hover panels don't work great with accesibility
        if (hasHover && hasHover.length > 0) {
            var win = window.open(ADAUrl, '_blank')
            if (win) {
                win.focus()

                return
            }
        }
        window.location = ADAUrl
    }
}

export const showDescription = () => (dispatch, getState) => {
    const visible = !getState().getIn(['tour', 'toggleDescriptionVisible'])
    if (visible) {
        dispatch(hideAvatar())
    } else {
        dispatch(showAvatar())
    }
    dispatch({
        type: TourActions.SHOW_DESCRIPTION,
        visible,
    })
}

export const showUIButton = visible => {
    return {
        type: TourActions.TOUR_NAV_HINT_BUTTON,
        visible,
    }
}

//AUTOPLAY ACTIONS

export const isAutoPlayBlocked = isAutoPlayBlocked => ({
    type: TourActions.IS_AUTO_PLAY_BLOCKED,
    isAutoPlayBlocked,
})

export const isAutoPlayEnabled = isAutoPlayEnabled => ({
    type: TourActions.IS_AUTO_PLAY_ENABLED,
    isAutoPlayEnabled,
})

export const showSkipButton = visible => ({
    type: TourActions.SHOW_SKIP,
    visible,
})

export const setIsWindowFullScreen = isWindowFullScreen => ({
    type: TourActions.IS_WINDOW_FULLSCREEN,
    isWindowFullScreen,
})

const initWalkingTourPhotos = (tour, { photo }) => (dispatch, getState) => {
    if (!photo) return

    const testSampleSize = 4,
        imageCacheSize = 5,
        container = window,
        includeHeight = true,
        onlySizeChange = false,
        resetcache = 0,
        isMediaTour = tour.type == TOUR_TYPES.mediatour,
        sizes = isMediaTour ? photo.sizes.mainMedia : photo.sizes.mainMediaWT

    WTPhotoController.init(
        sizes,
        testSampleSize,
        imageCacheSize,
        null,
        container,
        includeHeight,
        onlySizeChange,
        resetcache
    )
    AccessibilityController.init(getState().getIn(['device', 'isDeviceMobile']))
}

const initTourDrawer = ({ tourid, location, params }) => (dispatch, getState) => {
    const state = getState()
    const isDevicePhone = state.getIn(['device', 'isDevicePhone'])
    const { location: router } = state.get('routing')

    //hide the drawer after the loading screen is visible
    if (isDevicePhone && router.query.tourid) {
        setTimeout(() => {
            dispatch(hideDrawer())
        }, 500)
    }
    if (params.loc_id != location.loc_id || router.query.tourid != tourid) {
        if (hasMultipleToursLocations(state) && !params.loc_id && !router.query.tourid) {
            dispatch([
                showTourDrawer(),
                stopAudio(AUDIO_TOUR), //pause the audio on initial show tour drawer
            ])
        }
    }
}

export const showLandscapePrompt = prompt => ({
    type: TourActions.SET_LANDSCAPE_PROMPT,
    prompt,
})

const showWelcomePrompt = ({ location }) => (dispatch, getState) => {
    const state = getState()

    const isDevicePhone = state.getIn(['device', 'isDevicePhone'])

    if (!isDevicePhone) return

    const isRegistrationEnabled = state.getIn(['tour', 'registration', 'enabled'])
    const regWelcomePrompt = state.getIn(['tour', 'registration', 'welcomePrompt'])
    const modal = state.get('modal')
    const isMultipleLocations = hasMultipleToursLocations(state)

    //get the welcome modals
    const welcomeModal = modal.get('modalStack').filter(modal => {
        return (
            modal.content.type == ModalContentTypes.WELCOME ||
            modal.content.type == ModalContentTypes.WELCOME_REGISTRATION
        )
    })

    const initByCTA = modal.get('modalStack').filter(modal => {
        return modal.content.initBy == ModalSources.CTA_BUTTON_CLICKED
    })

    const hasShownPrompt = uriHandler.hasQueryParam(WELCOME_PROMPT_HIDDEN)

    //if there's no welcome prompt present, show it
    if (welcomeModal.size < 1) {
        let actions = []
        //stop audio when the welcome modal is visible
        actions.push(stopAudio(AUDIO_TOUR))

        if (isRegistrationEnabled) {
            actions.push(setRegistrationWelcomePrompt(true))
            actions.push(openWelcomeRegistrationModal())
        } else if (location.actionButtons.actions.length > 0 && isRegistrationEnabled != null) {
            // when there are no action buttons, dont show the welcome prompt
            actions.push(openWelcomeModal())
        }
        if (!hasShownPrompt) dispatch(actions)
        // if pressing back, and the welcome prompt is present, hide it
    } else if (
        (modal.get('modalStack').size > 0 &&
            (isMultipleLocations || (isRegistrationEnabled && !isMultipleLocations))) ||
        (!regWelcomePrompt && hasShownPrompt && !initByCTA)
    ) {
        dispatch(closeModal())
    }
}

export const setTourExpanded = isExpanded => ({
    type: TourActions.SET_TOUR_EMBED_EXPANDED,
    isExpanded,
})
